import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '磁力猫是什么？',
    answer: '磁力猫是一个专业的磁力链接搜索引擎，帮助用户快速搜索和找到影视、音乐、软件、电子书、游戏、动漫、纪录片、学习资料等各类数字资源的磁力链接。我们聚合了海量的磁力链接资源，提供高效精准的搜索服务。',
  },
  {
    question: '如何使用磁力猫搜索资源？',
    answer: '在搜索框中输入你想要查找的资源关键词，点击搜索或按回车键即可。你也可以通过首页的资源分类导航浏览不同类别的资源。找到想要的资源后，点击复制磁力链接按钮，将链接粘贴到你的下载客户端（如qBittorrent、BitComet等）即可开始下载。',
  },
  {
    question: '磁力链接下载速度快吗？',
    answer: '磁力链接的下载速度取决于资源的做种人数（Seeders）和你的网络环境。做种人数越多，下载速度越快。磁力猫会标注每个资源的做种数和下载数，帮助你选择下载速度最快的资源。建议优先选择做种数多、健康度高的资源。',
  },
  {
    question: '磁力猫需要注册账号吗？',
    answer: '不需要。磁力猫完全免费，无需注册即可使用所有搜索功能。我们致力于为用户提供最简单便捷的磁力链接搜索体验。',
  },
  {
    question: '磁力猫支持哪些类型的资源？',
    answer: '磁力猫目前支持八大资源分类：影视（电影、电视剧、综艺）、音乐（歌曲、专辑、演唱会）、软件（工具、系统、开发）、电子书（小说、技术、学术）、游戏（PC、主机、手游）、动漫（日漫、国漫、美漫）、纪录片（自然、历史、科技）、学习资料（课程、教程、考试）。',
  },
  {
    question: '使用磁力链接安全吗？',
    answer: '磁力链接本身是安全的，它只是文件内容的哈希标识符。但下载内容的安全性需要你自己判断。我们建议：下载前查看资源评论和评分，下载完成后先用杀毒软件扫描文件，避免打开可疑的可执行文件。如需更好的隐私保护，建议使用VPN。',
  },
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <section className="py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm text-foreground-500">
              关于磁力猫的使用，你可能想了解的问题
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 text-sm flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}